import { render, staticRenderFns } from "./lcsjDialog.vue?vue&type=template&id=1485ff90&scoped=true"
import script from "./lcsjDialog.vue?vue&type=script&lang=js"
export * from "./lcsjDialog.vue?vue&type=script&lang=js"
import style0 from "./lcsjDialog.vue?vue&type=style&index=0&id=1485ff90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485ff90",
  null
  
)

export default component.exports